import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UseGetAuthLinkBrizTv } from '../../../hooks/UseGetAuthLinkBrizTv';
import PopcornPng from '../../../assets/images/watchBrizTv/Popcorn.png';
import { ReactComponent as PlayIcon } from '../../../assets/images/plumpPlay.svg';
import { BasicButton } from '../../commons/buttons/BasicButton/BasicButton';
import { openNewBrowserTab } from '../../../services/domService';

export const BrizTvWatch: FC = () => {
  const { t } = useTranslation();
  const { getAuthLinkBrizTv, isLoadingGetAuthLinkBrizTv } = UseGetAuthLinkBrizTv();

  const handleBrizTv = async () => {
    if (isLoadingGetAuthLinkBrizTv) return;
    const link = await getAuthLinkBrizTv();
    openNewBrowserTab(link);
  };

  return (
    <BasicButton className="briz-tv-watch" handleClick={handleBrizTv as () => void}>
      <span className="online-cinema">
        <img src={PopcornPng} alt="popcorn" />
        <span className="column-dots" />
        <span className="briz-tv-cinema">
          <span className="tv-company">{t('header.brizTv')}</span>
          <span className="your-cinema">{t('brizTvWatch.onlineCinema')}</span>
        </span>
        <span className="column-dots" />
      </span>
      <span className="watch-now">
        <PlayIcon />
        {t('brizTvWatch.watchNow')}
      </span>
    </BasicButton>
  );
};
